"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Boilerplate = window.cccisd.boilerplate;
// import { HashLink } from 'react-router-hash-link';
// /**
//  * settings: {
//  *      "text": "sometext"
//  *      "isButton": true,
//  *      "buttonClassName": "",
//  *
//  *      "openBlank": true,
//  *      "path": "/dashboard/clients/{id}",
//  *      "pathVars": {
//  *           "id": {
//  *              "isStatic": false
//  *              dataPath: "row.id"
//  *          },
//  *          "value": {
//  *              "isStatic": true,
//  *              "value": 'foobar'
//  *          }
//  *      },
//  *      "search": {},
// *       "hash": "some class on the page",
// *   },
//     "useBreadcrumb": true
//  * }
//  */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData;
    var route = function route(routeStr, params) {
      var routeRet = routeStr;
      Object.keys(params).forEach(function (key) {
        routeRet = routeRet.replace("{".concat(key, "}"), params[key]);
      });
      return Boilerplate.settings.publicUrl + routeRet.slice(1);
    };
    var constructVars = function constructVars() {
      var pathVars = settings.pathVars;
      var newObj = {};
      Object.keys(pathVars).forEach(function (key) {
        if ('isStatic' in pathVars[key] && pathVars[key].isStatic) {
          newObj[key] = pathVars[key].value;
        } else {
          newObj[key] = (0, _get2["default"])(row, pathVars[key].dataPath);
        }
      });
      return newObj;
    };
    var getTarget = function getTarget() {
      if ('openBlank' in settings && settings.openBlank === true) {
        return {
          target: '_blank'
        };
      }
      return {
        target: '_self'
      };
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('table-renderers-link', 'text-nowrap')
    }, settings.isButton && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        if ('openBlank' in settings && settings.openBlank === true) {
          window.open(route(settings.path, constructVars()), '_blank');
        } else {
          window.location = route(settings.path, constructVars());
        }
      },
      style: {
        fill: 'currentColor'
      },
      className: settings.buttonClassName
    }, 'icon' in settings && /*#__PURE__*/_react["default"].createElement("span", {
      className: "icon"
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "15",
      height: "15",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: settings.icon.viewBox,
      color: "#fff"
    }, /*#__PURE__*/_react["default"].createElement("g", null, settings.icon.paths.map(function (p) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: p,
        d: p
      });
    })))), " ".concat(settings.text)), !settings.isButton && /*#__PURE__*/_react["default"].createElement("a", _extends({
      onClick: function onClick() {
        if ('openBlank' in settings && settings.openBlank === true) {
          window.open(route(settings.path, constructVars()), '_blank');
        } else {
          window.location = route(settings.path, constructVars());
        }
      }
    }, getTarget()), settings.text));
  };
};